//Ведущий ноль для mm:ss
const formatCountdown = (number: number) => {
	if (number < 10) {
		return `0${number}`
	}

	return number
}

//Секунды кулдауна в mm:ss
export const formatMinutesSeconds = (seconds: number) => {
	const m = Math.floor(seconds / 60)
	const s = seconds % 60
	return `${formatCountdown(m)}:${formatCountdown(s)}`
}
